var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from "react-router-dom";
import ApiRequests from "../../../classes/http/ApiRequests";
import HttpRequests from "../../../classes/http/HttpRequests";
import Grid from '../../../components/UI/Grid/Grid';
import AppRoutes from '../../../config/appRoutes';
var SlidesList = /** @class */ (function (_super) {
    __extends(SlidesList, _super);
    function SlidesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Картинка', key: 'image_url', formatter: 'image', filter: false, sort: false },
            { name: 'Линк', key: 'link', filter: false, sort: false },
            { name: 'Позиция', key: 'position', filter: false, sort: false },
        ];
        _this.getGridHeaders = function () {
            var _a = _this.props, brandId = _a.brandId, categoryId = _a.categoryId;
            if (brandId === "-1" && categoryId === "-1") {
                _this.gridHeaders.push({ name: 'Пускане на', key: 'start_date', filter: false, sort: false }, { name: 'Спиране на', key: 'stop_date', filter: false, sort: false });
            }
            return _this.gridHeaders;
        };
        _this.editSlide = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                if (_this.props.staticPageId !== "-1") {
                    var brandPath = AppRoutes.brand.path + "/" + _this.props.brandId;
                    var staticPagePath = AppRoutes.staticPage.path + "/" + _this.props.staticPageId;
                    var slidePath = AppRoutes.staticPageSlide.path + "/" + selectedId;
                    _this.props.history.push("" + brandPath + staticPagePath + slidePath);
                }
                else if (_this.props.brandId !== '-1') {
                    _this.props.history.push(AppRoutes.brand.path + '/' + _this.props.brandId + AppRoutes.brandSlide.path + ("/" + selectedId));
                }
                else if (_this.props.categoryId !== "-1") {
                    _this.props.history.push(AppRoutes.category.path + '/' + _this.props.categoryId + AppRoutes.categorySlide.path + ("/" + selectedId));
                }
                else {
                    _this.props.history.push(AppRoutes.editSlide.path.replace(':id', selectedId));
                }
            }
        };
        _this.deleteSlide = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0442\u043E\u0437\u0438 \u0441\u043B\u0430\u0439\u0434?");
            // Only proceed with deletion if the user confirmed the action
            if (ask) {
                var getDeleteActionMethod = function () {
                    if (_this.props.staticPageId !== "-1") {
                        return _this.api.deleteStaticPageSlide(_this.props.brandId, _this.props.staticPageId, selectedId);
                    }
                    if (_this.props.brandId !== "-1") {
                        return _this.api.deleteBrandSlide(selectedId, _this.props.brandId);
                    }
                    if (_this.props.categoryId !== "-1") {
                        return _this.api.deleteCategorySlide(selectedId, _this.props.categoryId);
                    }
                    return _this.api.deleteSlide(selectedId);
                };
                var actionMethod = getDeleteActionMethod();
                actionMethod
                    .then(function () {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Слайдът не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        return _this;
    }
    SlidesList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.getGridHeaders(), editAction: this.editSlide, paginator: true, deleteAction: this.deleteSlide, disableCategoryExtraColumn: true }));
    };
    return SlidesList;
}(React.Component));
// @ts-ignore
export default withRouter(SlidesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Slides/SlidesList/SlidesList.tsx
// module id = 466
// module chunks = 0